/* get language */
var path = window.location.pathname;
var isEn = false;
if(path.includes('/en/') || path == '/en'){
     isEn = true;
}
var isFr = false;
if(path.includes('/fr/') || path == '/fr'){
     isFr = true;
}
var isIt = false;
if(path.includes('/it/') || path == '/it'){
     isIt = true;
}
var isEs = false;
if(path.includes('/es/') || path == '/es'){
     isEs = true;
}

/* social icons */
var twitterIcon = '<a href="https://twitter.com/danholt4mac" class="social-link twitter" target="_blank"><svg class="svg-icon icon-twitter " xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="#1878b9" fill-rule="evenodd" d="M32 7c-1.2.6-2.4 1-3.8 1 1.4-.7 2.4-2 3-3.5-1.4.7-2.8 1.3-4.3 1.6-2-1-3-2-5-2-4 0-7 3-7 7v2c-5 0-10-3-13.6-7-.4 1-1 2-1 3.4 0 2 1.5 4 3 5.4-1 0-2-.3-3-1v.3c0 3 2.4 6 5.5 6l-1.8.6c-.4 0-.8 0-1.2-.2C4 23 6.7 25 9.4 25c-2 1.8-5 2.8-8 2.8H0c3 2 6.4 3 10 3 12 0 18.7-10 18.7-18.6v-1C30 9.6 31 8.6 32 7"></path></svg></a>';
var facebookIcon = '<a href="https://www.facebook.com/danholt4mac" class="social-link facebook" target="_blank"><svg class="svg-icon icon-facebook " xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="#1878b9" fill-rule="evenodd" d="M30.11 0H1.76C.786 0 0 .787 0 1.76v28.35c0 .97.787 1.758 1.76 1.758H17.02v-12.34H12.87v-4.81h4.152V11.17c0-4.116 2.514-6.357 6.185-6.357 1.76 0 3.27.13 3.712.19v4.3l-2.548.002c-1.997 0-2.384.95-2.384 2.342v3.07h4.763l-.62 4.81H21.99v12.34h8.12c.972 0 1.76-.787 1.76-1.758V1.76c0-.973-.788-1.76-1.76-1.76"></path></svg></a>';
var supportContent = document.querySelector('#shopify-section-template--15462798557396__16393839906a702480 .picture-block-content');
if(supportContent){
  innerHTML = supportContent.innerHTML;
  innerHTML += '<div class="vng-support-icons">' + twitterIcon + facebookIcon + '</div>'; 
  supportContent.innerHTML = innerHTML;
}
/* end social icons */
/* footer fix */
var width = window.innerWidth;
if(width < 911){
	var vngWrapper = document.getElementById('vng-vaeng-wrapper');
    vngWrapper.remove();
    var subFooterLeft = document.querySelector('.sub-footer__section--left');
    subFooterLeft.appendChild(vngWrapper);
    
}
/* end footer fix */
/* home page light button */
/*var homeLightContent = document.querySelector('.template-index #shopify-section-template--15437384286420__dynamic-image-with-text-1 .picture-block-content');
if(homeLightContent){
  var innerHTML = homeLightContent.innerHTML;
  if(isEn){
    innerHTML += '<div><a href="/en/pages/licht" class="action-button vng-home-btn">discover now</a></div>';
  }
  else if(isFr){
    innerHTML += '<div><a href="/fr/pages/licht" class="action-button vng-home-btn">découvrir maintenant</a></div>';
  }
  else if(isIt){
    innerHTML += '<div><a href="/it/pages/licht" class="action-button vng-home-btn">scorprire ora</a></div>';
  }
  else if(isEs){
    innerHTML += '<div><a href="/es/pages/licht" class="action-button vng-home-btn">Descubre ahora</a></div>';
  }  
  else {
    innerHTML += '<div><a href="/pages/licht" class="action-button vng-home-btn">jetzt entdecken</a></div>';
  }
  
  
  homeLightContent.innerHTML = innerHTML;
}*/
/* end home page light button */
/* home page air button */
/*var homeAirContent = document.querySelector('.template-index #shopify-section-template--15437384286420__dynamic-image-with-text-2 .picture-block-content');
if(homeAirContent){
  var innerHTML = homeAirContent.innerHTML;
  if(isEn){
    innerHTML += '<div><a href="/en/pages/gocycle" class="action-button vng-home-btn">discover now</a></div>';
  }
  else if(isFr){
    innerHTML += '<div><a href="/fr/pages/gocycle" class="action-button vng-home-btn">découvrir maintenant</a></div>';
  }
  else if(isIt){
    innerHTML += '<div><a href="/it/pages/gocycle" class="action-button vng-home-btn">scorprire ora</a></div>';
  }
  else if(isEs){
    innerHTML += '<div><a href="/es/pages/gocycle" class="action-button vng-home-btn">Descubre ahora</a></div>';
  }  
  else {
    innerHTML += '<div><a href="/pages/gocycle" class="action-button vng-home-btn">jetzt entdecken</a></div>';
  }
  
  homeAirContent.innerHTML = innerHTML;
}*/
/* end home page air button */
/* home page doorbird button */
var homeDoorbirdContent = document.querySelector('.template-index #shopify-section-template--15437384286420__164612667375b07cb6 .featured-text-container');
if(homeDoorbirdContent){
  var innerHTML = homeDoorbirdContent.innerHTML;
  if(isEn){
     innerHTML += '<div><a href="/en/pages/doorbird" class="action-button vng-home-btn">discover now</a></div>';
  }
  else if(isFr){
     innerHTML += '<div><a href="/fr/pages/doorbird" class="action-button vng-home-btn">découvrir maintenant</a></div>';
  }
  else if(isIt){
     innerHTML += '<div><a href="/it/pages/doorbird" class="action-button vng-home-btn">scorprire ora</a></div>';
  }
  else if(isEs){
     innerHTML += '<div><a href="/es/pages/doorbird" class="action-button vng-home-btn">Descubre ahora</a></div>';
  }  
  else {
     innerHTML += '<div><a href="/pages/doorbird" class="action-button vng-home-btn">jetzt entdecken</a></div>';
  }
 
  homeDoorbirdContent.innerHTML = innerHTML;
}
/* end home page doorbird button */
/* home page smart living link */
var homePageSmartLivingLink = document.querySelector('.template-index #shopify-section-template--15437384286420__16384477764a6e1c8e .collection-wrap:nth-of-type(1) a');
if(homePageSmartLivingLink){
  if(isEn){
    homePageSmartLivingLink.href = '/en/pages/smart-living'; 
  }
  else if(isFr){
    homePageSmartLivingLink.href = '/fr/pages/smart-living'; 
  }
  else if(isIt){
    homePageSmartLivingLink.href = '/it/pages/smart-living'; 
  }
  else if(isEs){
    homePageSmartLivingLink.href = '/es/pages/smart-living'; 
  }  
  else {
    homePageSmartLivingLink.href = '/pages/smart-living';
  }
}
/* home page smart living link */
/* home page smart sports link */
var homePageSmartSportsLink = document.querySelector('.template-index #shopify-section-template--15437384286420__16384477764a6e1c8e .collection-wrap:nth-of-type(2) a');
if(homePageSmartSportsLink){
  if(isEn){
    homePageSmartSportsLink.href = '/en/pages/smart-sports-gesundheit';
  }
  else if(isFr){
    homePageSmartSportsLink.href = '/fr/pages/smart-sports-gesundheit';
  }
  else if(isIt){
    homePageSmartSportsLink.href = '/it/pages/smart-sports-gesundheit';
  }
  else if(isEs){
    homePageSmartSportsLink.href = '/es/pages/smart-sports-gesundheit';
  } 
  else {
    homePageSmartSportsLink.href = '/pages/smart-sports-gesundheit';
  }
  
}
/* home page smart sports link */
/* home page smart biking link */
/* var homePageSmartBikingLink = document.querySelector('.template-index #shopify-section-template--15437384286420__16384477764a6e1c8e .collection-wrap:nth-of-type(3) a');
if(homePageSmartBikingLink){
  if(isEn){
    homePageSmartBikingLink.href = '/en/pages/gocycle';
  }
  else if(isFr){
    homePageSmartBikingLink.href = '/fr/pages/gocycle';
  }
  else if(isIt){
    homePageSmartBikingLink.href = '/it/pages/gocycle';
  }
  else {
    homePageSmartBikingLink.href = '/pages/gocycle';
  }
  
}
*/
/* Footer Translation Fix */
var footerLegalHeadings = document.querySelectorAll('.footer-linklist-one li strong');
if(footerLegalHeadings){
  if(isEn){
  	footerLegalHeadings.forEach(function(item){
      if(item.innerHTML == 'Rechtliches'){
        item.innerHTML = 'Legal';
      }
    });
  }
  if(isFr){
  	footerLegalHeadings.forEach(function(item){
      if(item.innerHTML == 'Rechtliches'){
        item.innerHTML = 'Mentions légales';
      }
    });
  }
  if(isIt){
  	footerLegalHeadings.forEach(function(item){
      if(item.innerHTML == 'Rechtliches'){
        item.innerHTML = 'Informazioni legali';
      }
    });
  }
}

/* Footer Language Selector Temp */
/*var footerLanguageLinks = document.querySelectorAll('#localization_form .disclosure li');
var counter = 0;
if(footerLanguageLinks){
  	footerLanguageLinks.forEach(function(item){
      if(counter == 2){
        item.remove();
      }
      counter++;
    });
}*/

/* Safari (Desktop) Fix for Language Selector */
var width = window.innerWidth;
var isSafari = window.safari !== undefined; 
if(isSafari && width >= 1150){
  document.head.insertAdjacentHTML("beforeend", `<style>body #etranslate-language-float-selector {top: 27px !important }</style>`)
  console.log('safari fix');
}




